import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
	getSettingsUsers,
	UpdateStatusSettingsUser,
} from '../../../../../../services/settings/users';

const useUsers = () => {
	const [bulkAction, setBulkAction] = useState([]);
	const [usersList, setUsersList] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Users');
	const [loader, setLoder] = useState(false);
	const [sortDirection, setSortDirection] = useState(false);

	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
		filterBy: '',
		filterValue: '',
	});
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const onRowClick = (id) => {};
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};
	const handleFilterData = (type, value, key) => {
		setParams((prev) => ({
			...prev,
			filterBy: key,
			filterValue: value,
		}));
		setHeaderDropDown(type);
	};

	const handleDisable = async (e, id, status) => {
		try {
			e.stopPropagation();
			const data = {
				is_active: status,
			};
			const res = await UpdateStatusSettingsUser(data, id);
			if (res.success) {
				toast.success(res.message);
				getUsersList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.organisation_user_id,
				user: JSON.stringify({
					id: ele.organisation_user_id,
					name: `${ele.first_name} ${ele.last_name}`,
					phone_number: ele.phone_number,
					email: ele.email,
					is_active: ele.is_active,
				}),
				role: ele.role !== null && ele.role !== undefined ? ele.role.name : 'N/A',
				action: JSON.stringify({
					id: ele.organisation_user_id,
					is_active: ele.is_active,
				}),
			};
		});
	}
	const getUsersList = async () => {
		try {
			setLoder(true);
			const { users } = await getSettingsUsers(params);
			const data = mappedTableData(users);
			setUsersList(data);
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		} finally {
			setLoder(false);
		}
	};
	useEffect(() => {
		getUsersList();
	}, [params]);
	return {
		usersList,
		getUsersList,
		headerDropDown,
		setHeaderDropDown,
		loader,
		sortDataList,
		sortDirection,
		handleFilterData,
		bulkAction,
		setBulkAction,
		onRowClick,
		handleDeselectAll,
		handleDisable,
	};
};
export default useUsers;
